export default __webpack_public_path__ + "static/media/Group 2.0087a6db.svg";